import React, { useState } from "react";
import signinimage from "../../images/signin-g.svg";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../ScrollToTop";
import axios from "axios";
import Header from "../../Component/Header";
import { IconButton, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { px } from "framer-motion";
import { useTranslation } from "react-i18next";

const MyAccountSignIn = () => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const [role, setrole] = useState();
  const { t, i18n } = useTranslation();
  const policyPageUrl = "/policies-legal";
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://sakhisshop.com/api/users/login",
        credentials,
      );
      // console.log("✅ Response from backend:", response.data);

      const { token, role, sID, id, username, cID, rmId } = response.data;

      // ✅ Save common values to localStorage
      if (token) {
        localStorage.setItem("token", token);
        console.log("🔐 Token saved");
      }

      if (username) {
        localStorage.setItem("user", JSON.stringify(response.data));
        console.log("🙋‍♂ Username saved:", username);
      }

      if (role) {
        const roleUpper = role.toUpperCase();
        localStorage.setItem("role", roleUpper);
        console.log("🧑‍💼 Role saved:", roleUpper);

        // ✅ Save user-specific IDs based on role
        if (roleUpper === "SHOPKEEPER" && sID !== undefined && sID !== null) {
          localStorage.setItem("shopkeeperID", sID.toString());
          localStorage.setItem("shopName", response.data.shopName);
          console.log(" Shopkeeper ID saved:", sID);
        } else if (
          roleUpper === "CUSTOMER" &&
          cID !== undefined &&
          cID !== null
        ) {
          localStorage.setItem("customerId", cID.toString());
          localStorage.setItem("customerName", response.data.customerName);
          console.log("customerId saved:", cID);
        }
        if (roleUpper === "DELIVERYBOY" && id !== undefined && id !== null) {
          localStorage.setItem("deliveryBoy", JSON.stringify(response.data)); // ✅ stores full object
          localStorage.setItem("deliveryId", id.toString()); // ✅ stores plain ID
          console.log("✅ DeliveryBoy saved:", id);
        } else if (roleUpper === "RM" && rmId) {
          localStorage.setItem("rmId", rmId.toString());
          localStorage.setItem("userId", rmId.toString()); // 👈 ADD THIS LINE

          console.log("✅ RM ID saved:", rmId);
        }

        // ✅ Navigate based on role
        switch (roleUpper) {
          case "ADMIN":
            navigate("/admin-dashboard");
            break;
          case "SUPERADMIN":
            navigate("/superadmin-dashboard");
            break;
          case "CUSTOMER":
            navigate("/customer-dashboard");
            break;
          case "SHOPKEEPER":
            navigate("/create-ShopkeeperInv");
            break;
          case "EMPLOYEE":
            navigate("/create-ShopkeeperInv");
            break;
          case "DELIVERYBOY":
            navigate("/deliveryBoyDashboard");
            break;
          case "RM":
            const rmData = response.data;

            localStorage.setItem("role", rmData.role);
            localStorage.setItem("rmId", rmData.rmId);
            localStorage.setItem("rmName", rmData.name);
            localStorage.setItem("rmMobile", rmData.mobileNo);

            console.log("✅ RM Stored:", rmData);

            navigate("/superadmin-dashboard"); // 👈 Set your RM dashboard path
            break;
          default:
            alert("❌ Unknown role! No dashboard assigned.");
        }
      } else {
        alert("❌ Login failed: Missing role in response!");
      }
    } catch (error) {
      console.error("❌ Login error:", error);
      alert("Invalid username or password!");
    }
  };

  return (
    <div>
      <Header />
      <ScrollToTop />
      <section className="my-lg-14 my-8 py-8" style={{ marginTop: "120x" }}>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img src={signinimage} alt="signin" className="img-fluid" />
            </div>
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1">
              <div className="mb-lg-9 mb-5">
                <h1
                  className="fw-bold text-center"
                  style={{
                    fontSize: window.innerWidth < 600 ? "1.8rem" : "1.5rem",
                    fontFamily: "'Poppins', sans-serif",
                    color: "#1976d2",
                    marginBottom: "1rem",
                  }}
                >
                  {/* <IconButton onClick={() => navigate(-1)} size="small" color="warning">
    <ArrowBackIosNewIcon fontSize="large" /> */}
                  {/* <Typography sx={{ fontSize: "14px", fontWeight: 600, textTransform: "uppercase" }}>
      Back
    </Typography> */}
                  {/* </IconButton> */}
                  Sign in to{" "}
                  <span style={{ color: "#d81b60" }}>Sakhi's Shop</span>
                </h1>

                <p
                  className="text-center"
                  style={{
                    fontSize: window.innerWidth < 600 ? "0.95rem" : "1.0rem",
                    color: "#555",
                    marginTop: "-0.5rem",
                  }}
                >
                  Welcome back! Please sign in to continue.
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12">
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      placeholder="Username"
                      value={credentials.username}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="password"
                      placeholder="Password"
                      value={credentials.password}
                      onChange={handleChange}
                      required
                    />

                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                      ></i>
                    </span>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="rememberMe"
                      />
                      <label className="form-check-label" htmlFor="rememberMe">
                        Remember me
                      </label>
                    </div>
                    <div>
                      Forgot password?{" "}
                      <Link to="/MyAccountForgetPassword">Reset it</Link>
                    </div>
                  </div>
                  <div className="col-12 d-grid">
                    <button type="submit" className="btn btn-primary">
                      Sign In
                    </button>
                  </div>
                  <div className="col-12">
                    <small className="text-muted">
                      Please read our <a href={policyPageUrl}>Privacy Policy</a>
                      ,{" "}
                      {/* <a href={policyPageUrl}>Refund Policy</a>{" "}
                      and{" "}
                      <a href={policyPageUrl}>App Usage MOU</a>. */}
                    </small>
                  </div>
                  {/* <div>
                    Don’t have an account? <Link to="/CustomerProfileRegistration"> Sign Up</Link>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountSignIn;
